import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { ServiceBase } from './service.base';
import { TableLazyLoadEvent } from 'primeng/table';

@Injectable({
  providedIn: 'root'
})
export class ApplicationLogService extends ServiceBase {

  public api = '/ApplicationLog';

  constructor(private http: HttpClient, authService: AuthService) {
    super(authService);
  }

  // public getApplicationLogs(): Observable<LogEntryResponse[]> {
  //   var httpOptions = this.RequestHeaders();
  //   const method: string = '/logs';
  //   const url: string = environment.BASE_API_PATH + this.api + method;
  //   return this.http.get<LogEntryResponse[]>(url, httpOptions);
  // }

  // public getEmailTrackLogs(): Observable<EmailTrackResponce[]> {
  //   var httpOptions = this.RequestHeaders();
  //   const api = '/EmailTrack'
  //   const method: string = '/logs';
  //   const url: string = environment.BASE_API_PATH + api + method;
  //   return this.http.get<EmailTrackResponce[]>(url, httpOptions);
  // }

  public getApplicationLogs($event: TableLazyLoadEvent): Observable<LazyLoadingResponse<LogEntryResponse>> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/logs';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<LazyLoadingResponse<LogEntryResponse>>(url, $event, httpOptions);
  }

  public getEmailTrackLogs($event: TableLazyLoadEvent): Observable<LazyLoadingResponse<EmailTrackResponce>> {
    var httpOptions = this.RequestHeaders();
    const api = '/EmailTrack'
    const method: string = '/logs';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<LazyLoadingResponse<EmailTrackResponce>>(url, $event, httpOptions);
  }
}

export class LogEntryResponse {
  Id!: number;
  LogDate!: Date;
  Level!: string;
  Logger!: string;
  Message!: string;
  Exception!: string;
  Method!: string;
  MessageTemplate!: string;
  Properties!: string;
  TimeStamp!: Date;
}

export class EmailTrackResponce  {
  Id!: string;
  SentTo!: string;
  Event!: string;
  Subject!: string;
  IsSentSuccessfully!: boolean;
  EventDescription!: string;
  ActionDate!: Date;
  EmailDeliveryStatus!: string;
  FailureReason?: string | null;
  FailureResponse?: string | null;
  LastUpdatedDate!: Date;
  MessageId!: string;
}

export class LazyLoadingResponse<T> {
  filteredResultsCount!: number;
  totalResultsCount!: number;
  data?: T[];
  totalRecords!: number;
}